module.exports = __webpack_public_path__ + "static/media/yourlogohere.1ecba3e9.png";